import {
    DELETE_ALERTS,
    DELETE_ALERTS_FAILURE,
    DELETE_ALERTS_SUCCESS,
    GET_ALERTS,
    GET_ALERTS_SUCCESS,
    GET_ALERTS_FAILURE,
    MARK_ALERTS_READ,
    MARK_ALERTS_READ_FAILURE,
    MARK_ALERTS_READ_SUCCESS,
    GET_FILTER_DISTRICTS,
    GET_FILTER_DISTRICTS_SUCCESS,
    GET_FILTER_DISTRICTS_FAILURE,
    GET_FILTER_TERRITORIES,
    GET_FILTER_TERRITORIES_SUCCESS,
    GET_FILTER_TERRITORIES_FAILURE,
    GET_FILTER_ACCOUNTS,
    GET_FILTER_ACCOUNTS_SUCCESS,
    GET_FILTER_ACCOUNTS_FAILURE,
    SET_FILTER_ALERT,
    SET_SEARCHBAR_TEXT,
    RESET_ALERTS_LIST,
    SET_SELECTED_ALERT_IDS,
} from 'src/pages/alerts/redux/action';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    alerts: [],
    selectedIds: [],
    districtsFilterData: [],
    territoriesFilterData: [],
    accountsFilterData: [],
    totalResults: 0,
    totalUnreadCount: 0,
    loading: false,
    hasFetched: false,
    requestPayload: {},
    error: '',
    appliedAlertFilters: {},
    searchbarText: {},
};

const alertsReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_SELECTED_ALERT_IDS:
            return {
                ...state,
                selectedIds: action.payload,
            };
        case GET_ALERTS:
            return {
                ...state,
                loading: true,
                error: '',
                requestPayload: action.payload ?? {},
            };
        case GET_ALERTS_SUCCESS:
            return {
                ...state,
                loading: false,
                hasFetched: true,
                alerts: action.payload?.alerts ?? [],
                totalResults: action.payload?.totalResults ?? 0,
                totalUnreadCount: action.payload?.totalUnreadCount ?? 0,
                error: '',
            };
        case GET_ALERTS_FAILURE:
            return {
                ...state,
                loading: false,
                hasFetched: true,
                error: action.error ?? 'Unable to load alerts',
            };
        case RESET_ALERTS_LIST:
            return {
                ...state,
                alerts: initialState.alerts,
                totalResults: initialState.totalResults,
                totalUnreadCount: initialState.totalUnreadCount,
                loading: initialState.loading,
                hasFetched: initialState.hasFetched,
                requestPayload: initialState.requestPayload,
                error: initialState.error,
            };
        case DELETE_ALERTS:
            return {
                ...state,
                loading: true,
                error: '',
            };
        case DELETE_ALERTS_SUCCESS: {
            return {
                ...state,
                loading: true,
                error: '',
            };
        }
        case DELETE_ALERTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error ?? 'Unable to delete alerts',
            };
        case MARK_ALERTS_READ:
            return {
                ...state,
                loading: true,
                error: '',
            };
        case MARK_ALERTS_READ_SUCCESS:
            return {
                ...state,
                loading: true,
                error: '',
            };
        case GET_FILTER_DISTRICTS:
        case GET_FILTER_TERRITORIES:
        case GET_FILTER_ACCOUNTS:
            return {
                ...state,
                accountsFilterData: {
                    ...state.accountsFilterData,
                    loading: true,
                    error: '',
                },
            };
        case GET_FILTER_DISTRICTS_SUCCESS:
            return {
                ...state,
                districtsFilterData: {
                    ...state.districtsFilterData,
                    loading: false,
                    error: '',
                    districts: action.payload ?? [],
                }
            };
        case GET_FILTER_TERRITORIES_SUCCESS:
            return {
                ...state,
                territoriesFilterData: {
                    ...state.territoriesFilterData,
                    loading: false,
                    error: '',
                    territories: action.payload ?? [],
                },
            };
        case GET_FILTER_ACCOUNTS_SUCCESS:
            return {
                ...state,
                accountsFilterData: {
                    ...state.accountsFilterData,
                    loading: false,
                    error: '',
                    accounts: action.payload ?? [],
                },
            };
        case GET_FILTER_DISTRICTS_FAILURE:
        case GET_FILTER_TERRITORIES_FAILURE:
        case GET_FILTER_ACCOUNTS_FAILURE:
            return {
                ...state,
                // Alerts are only fetched after districts resolve, so a district failure ends the initial load.
                ...(action.type === GET_FILTER_DISTRICTS_FAILURE && { hasFetched: true }),
                districtsFilterData: {
                    ...state.districtsFilterData,
                    loading: false,
                    error: action.error ?? 'Unable to load filter data',
                },
                territoriesFilterData: {
                    ...state.territoriesFilterData,
                    loading: false,
                    error: action.error ?? 'Unable to load filter data',
                },
                accountsFilterData: {
                    ...state.accountsFilterData,
                    loading: false,
                    error: action.error ?? 'Unable to load filter data',
                },
            };
        case SET_FILTER_ALERT:
            return {
                ...state,
                appliedAlertFilters: action.payload ?? {},
            };
        case SET_SEARCHBAR_TEXT:
            // supports both a single { filterType, value } update and a full reset object
            return {
                ...state,
                searchbarText: action.payload?.filterType
                    ? {
                        ...state.searchbarText,
                        [action.payload.filterType]: action.payload.value ?? '',
                    }
                    : { ...action.payload },
            };
        case MARK_ALERTS_READ_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error ?? 'Unable to mark alerts as read',
            };
        default:
            return { ...state };
    }
};

export default persistReducer(
    {
        key: 'alertsReducerKey',
        storage: storage,
        whitelist: ['appliedAlertFilters', 'selectedIds'],
    },
    alertsReducer
);
